<template>
  <div
    class="mission-card-check-list"
    :class="[`color-type-${mission.colorType}`, { 'is-completed': mission.hasCompleted }]"
  >
    <div
      v-for="(condition, i) in mission.achievementCondition"
      :key="i"
      class="mission-card-check-list__item"
    >
      <mission-hexagon-parts :condition="condition" :mission="mission" />
      <p v-if="!mission.hasCompleted" class="mission-card-check-list__item-name">
        {{ condition.missionNameOnCheckList }}
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import MissionHexagonParts from '@/components/MissionPage/MissionListPane/parts/MissionHexagonParts.vue'
import { MissionProgressCardType } from '@/components/MissionPage/hook/useMissionProgressData'

/**
 * ミッション画面 ミッション達成状況 獲得済みポイントパーツ
 */
export default defineComponent({
  name: 'MissionCheckListParts',
  components: { MissionHexagonParts },
  props: {
    mission: {
      type: Object as PropType<MissionProgressCardType>,
      required: true,
    },
  },
})
</script>

<style scoped lang="scss">
.mission-card-check-list {
  width: 100%;

  &.color-type-1 {
    .mission-card-check-list__item-name {
      color: #73ffdd;
    }
  }

  &.color-type-2 {
    .mission-card-check-list__item-name {
      color: #e0ffa0;
    }
  }

  &.color-type-3 {
    .mission-card-check-list__item-name {
      color: #f7c6ff;
    }
  }

  &.color-type-4 {
    .mission-card-check-list__item-name {
      color: #ff5d5d;
    }
  }

  &.is-completed {
    display: flex;
    gap: 6px;

    .mission-card-check-list__item {
      justify-content: center;
      padding: 0;
    }
  }

  &__item {
    display: flex;
    align-items: center;
    padding: 12px 15px;

    &:nth-child(odd) {
      background-color: $black10;
    }
  }

  &__item-name {
    margin-left: 12px;
    font-size: 14px;
    letter-spacing: 0.02em;
  }
}
</style>
